export default {

  'get_search_string': () => {
    let so = {};
    if (document.location.search) {
      const s = document.location.search.slice(1).split('&');
      if (s) {
        let sp;
        for (let i = 0; i < s.length; i++) {
          sp = s[i].split('=');
          so[sp[0]] = sp[1] ? sp[1] : true;
        }
      }
    }
    return so;
  }

};